import { Box, Typography } from '@mui/material';
import { SsbRaceResult, SsbReferenceGroupResult } from '../../types/SimilarlySituated/SsbAnalysisResult.type';
import { SsbRateMode } from '../../types/enums/SsbRateMode.enum';
import { formatRate, raceLabel, resultRaces } from '../../utils/ssbResults';

interface OutcomeResultChartProps {
  group: SsbReferenceGroupResult;
  mode: SsbRateMode;
}

const NOT_ESTIMABLE_BAR = 'repeating-linear-gradient(135deg, #E2E8F0 0 4px, #F7FAFC 4px 8px)';

function OutcomeResultChart({ group, mode }: OutcomeResultChartProps) {
  const races = resultRaces(group);
  const maxRate = Math.max(0, ...races.map((race) => group.results_by_race[race]?.rate ?? 0));

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content minmax(0, 1fr) max-content',
        alignItems: 'center',
        columnGap: '16px',
        rowGap: '12px',
      }}
    >
      {races.map((race) => {
        const row = group.results_by_race[race] as SsbRaceResult;
        const width = row.rate !== null && maxRate > 0 ? (row.rate / maxRate) * 100 : 0;

        return (
          <Box key={race} sx={{ display: 'contents' }}>
            <Typography sx={{ fontSize: '13px', whiteSpace: 'nowrap', paddingRight: '24px' }}>
              {raceLabel(race)}
            </Typography>
            <Box
              role='img'
              aria-label={`${raceLabel(race)} ${formatRate(row.rate, mode)}`}
              sx={{
                height: '20px',
                borderRadius: '4px',
                background: row.rate === null ? NOT_ESTIMABLE_BAR : '#F1F5F9',
                overflow: 'hidden',
              }}
            >
              <Box sx={{ width: `${width}%`, height: '100%', borderRadius: '4px', backgroundColor: 'primary.main' }} />
            </Box>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#718096',
                fontStyle: row.rate === null ? 'italic' : 'normal',
                whiteSpace: 'nowrap',
              }}
            >
              {row.rate === null ? 'not estimable' : `${formatRate(row.rate, mode)} · n=${row.denominator ?? 0}`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default OutcomeResultChart;
